import { useLanguage } from "../../stores/LanguageStore";
import {
  ActionIcon,
  Button,
  CopyButton,
  Group,
  Menu,
  Stack,
  Text,
  TextInput,
  Tooltip,
} from "@mantine/core";
import {
  IconCheck,
  IconCopy,
  IconSearch,
  IconVariable,
} from "@tabler/icons-react";
import { useEffect, useState } from "react";
import ReplacementVariables from "../View/ReplacementVariables";
import UnsubscribeVariableTooltip from "./UnsubscribeVariableTooltip";
import WebversionVariableTooltip from "./WebversionVariableTooltip";

const AddTokens = ({
  items,
  handleAdd,
  long,
  buttonProps,
  position = "bottom-start",
}) => {
  const [opened, setOpened] = useState(false);
  const [searchItems, setSearchItems] = useState(items || []);
  const lang = useLanguage((s) => s.language);
  const handleOptionAdd = (item) => {
    setOpened(false);
    handleAdd(item);
  };

  const handleInput = (e) => {
    let search = e.target.value;

    let filtered = items.filter((x) => {
      let nameContained = x.label.toLowerCase().includes(search.toLowerCase());
      let valueContained = x.value.toLowerCase().includes(search.toLowerCase());

      return nameContained || valueContained;
    });

    setSearchItems(filtered);
  };

  useEffect(() => {
    if (opened) {
      setSearchItems(items);
      setTimeout(() => {
        document.getElementById("search-datafield").focus();
      }, 100);
    }
  }, [opened]);

  return (
    <Menu zIndex={1200} position={position} onChange={setOpened} opened={opened} withOverlay overlayProps={{opacity: 0}} >
      <Menu.Target>
        {long ? (
          <Button
            variant="light"
            leftSection={<IconVariable size={18} />}
            size="sm"
            h={32}
            onClick={() => setOpened((prev) => !prev)}
            {...buttonProps}
          >
            Variables
          </Button>
        ) : (
          <Tooltip label={lang.components.variable_manager.add_variable}>
            <ActionIcon
              variant="light"
              className="to-blue"
              radius={"md"}
              onClick={() => setOpened((prev) => !prev)}
              {...buttonProps}
            >
              <IconVariable size={18} />
            </ActionIcon>
          </Tooltip>
        )}
      </Menu.Target>
      <Menu.Dropdown
        style={{ overflow: "auto" }}
        // onBlur={() => setOpened(false)}
      >
        <TextInput
          placeholder={lang.global.search}
          rightSection={<IconSearch size={16} />}
          onChange={handleInput}
          mb={4}
          // autoFocus
          // data-autofocus
          id="search-datafield"
        />
        <Stack mah={"30vh"} style={{ overflow: "auto" }} gap={2}>
          {searchItems?.map((item) => (
            <Group key={item.value} wrap="nowrap" gap={"xs"}>
              <Menu.Item onClick={() => handleOptionAdd(item)}>
                <Stack gap={0}>
                  <Text mr={8} size="sm" fw={500}>
                    {item.label}
                    {item?.required ? " *" : ""}
                  </Text>
                </Stack>
              </Menu.Item>
              {
                item.value === "%unsubscribe%" &&
                <UnsubscribeVariableTooltip />
              }
              {
                item.value === "%webversion%" &&
                <WebversionVariableTooltip />
              }
              <CopyButton value={item.value}>
                {({ copied, copy }) => (
                  <Tooltip
                    label={
                      copied
                        ? lang.global.copied
                        : `${lang.global.copy} variable`
                    }
                    color={copied ? "green" : "black"}
                  >
                    <ActionIcon
                      size={"sm"}
                      variant="light"
                      color={copied ? "green" : "primary"}
                      onClick={(e) => {
                        e.stopPropagation();
                        copy();
                        setOpened(true);
                      }}
                    >
                      {copied ? (
                        <IconCheck size={16} />
                      ) : (
                        <IconCopy size={16} />
                      )}
                    </ActionIcon>
                  </Tooltip>
                )}
              </CopyButton>
            </Group>
          ))}
        </Stack>
        <Menu.Divider />
        <ReplacementVariables />
      </Menu.Dropdown>
    </Menu>
  );
};

export default AddTokens;
